import { SearchOutlined, FileExcelOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  DatePicker,
  // Form,
  Input,
  Menu,
  Row,
  Space,
  Table,
  Tooltip,
  Spin,
  message,
} from 'antd';
import { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../../Images/ColumnList.svg';
import { ReactComponent as FilterIcon } from '../../../Images/FilterIcon.svg';
import { ReactComponent as PrintIcon } from '../../../Images/PrintIcon.svg';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInwardPackingReport } from '../../../slices/report';
import eventBus from '../../../utils/eventBus';
import { CSVLink } from 'react-csv';
import logo from '../../../Images/alux-logo.png';
import jsPDF from 'jspdf';

dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;

function PackingReportList() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { user: currentUser } = useSelector(state => state.auth);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [orderBy, setOrderBy] = useState('');
  const { data = [] } = useSelector(state => state.report);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [dateRange, setDateRange] = useState([
    dayjs().startOf('month'),
    dayjs(),
  ]);

  const handleSearch = e => {
    setSearch(e.target.value);
    setPage(1);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'name' && sortOrder === 'ascend') {
      sortingEnumKey = 'name';
    }
    if (sortField === 'name' && sortOrder === 'descend') {
      sortingEnumKey = '-name';
    }

    return sortingEnumKey;
  };

  const handleDateRangeChange = dates => {
    if (dates) {
      setDateRange(dates);
    }
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     const params = {
  //       page,
  //       pagesize,
  //       ...(search && { search }),
  //       ...(orderBy && { ordering: orderBy }),
  //     };
  //     if (dateRange && dateRange[0] && dateRange[1]) {
  //       params.start_date = dateRange[0].format('YYYY-MM-DD');
  //       params.end_date = dateRange[1].format('YYYY-MM-DD');
  //     }
  //     try {
  //       await dispatch(fetchInwardPackingReport(params)).unwrap();
  //     } catch (error) {
  //       console.error('API fetch error:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [dispatch, page, pagesize, search, orderBy, dateRange]);

  const fetchPackingReportData = useCallback(() => {
    setLoading(true);
    const params = {
      page,
      pagesize,
      ...(search && { search }),
      ...(orderBy && { ordering: orderBy }),
    };
    if (dateRange && dateRange[0] && dateRange[1]) {
      params.start_date = dateRange[0].format('YYYY-MM-DD');
      params.end_date = dateRange[1].format('YYYY-MM-DD');
    }
    try {
      dispatch(fetchInwardPackingReport(params)).unwrap();
    } catch (error) {
      console.error('API fetch error:', error);
    } finally {
      setLoading(false);
    }
  }, [dispatch, page, pagesize, search, orderBy, dateRange]);


  useEffect(() => {
    fetchPackingReportData();
  }, [fetchPackingReportData]);

  useEffect(() => {
    const handleReload = () => {
      fetchPackingReportData();
    };

    eventBus.on("financialYear:refresh", handleReload);

    return () => {
      eventBus.off("financialYear:refresh", handleReload);
    };
  }, [fetchPackingReportData]);

  const resetFilter = () => {
    setSearch('');
    setPage(1);
    setOrderBy('');
  };
  const handlePageChange = newPage => {
    setPage(newPage);
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setPageSize(pagination.pageSize);
    setOrderBy(orderBy);
  };

  const mappedData = data.map((item, idx) => ({
    sr_no: (page - 1) * pagesize + idx + 1,
    ...item,
    key: (page - 1) * pagesize + idx + 1,
  }));

  const csvHeaders = [
    { label: 'Sr No.', key: 'sr_no' },
    { label: 'Date', key: 'date' },
    { label: 'Shift A', key: 'shift_a' },
    { label: 'Shift B', key: 'shift_b' },
    { label: 'Total', key: 'total' },
  ];
  const csvData = mappedData;

  const handlePrintDownloadAll = async () => {
    setLoading(true);
    try {
      const params = {
        page: 1,
        pagesize: 10000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
        ...(dateRange && dateRange[0] && dateRange[1] && {
          start_date: dateRange[0].format('YYYY-MM-DD'),
          end_date: dateRange[1].format('YYYY-MM-DD'),
        }),
      };

      const response = await dispatch(fetchInwardPackingReport(params)).unwrap();
      const allData = response?.data || [];
      if (allData.length === 0) {
        message.error('No data available to print.');
        setLoading(false);
        return;
      }

      const pdf = new jsPDF('p', 'pt', 'a4');
      pdf.setFont('times');
      const pageWidth = pdf.internal.pageSize.width;
      const footerHeight = 40;
      const margin = { top: 80, left: 20, right: 20, bottom: footerHeight + 40 };

      pdf.setFontSize(14);
      pdf.text('Packing Report', pageWidth / 2, 40, { align: 'center' });

      // ✅ Build dynamic header based on checkedList
      const columnMap = {
        sr_no: { label: 'Sr No.', getValue: (item, idx) => idx + 1 },
        date: { label: 'Date', getValue: (item) => item.date ? dayjs(item.date).format('DD-MM-YYYY') : 'N/A' },
        shift_a: { label: 'Shift A', getValue: (item) => item.shift_a || 'N/A' },
        shift_b: { label: 'Shift B', getValue: (item) => item.shift_b || 'N/A' },
        total: { label: 'Total', getValue: (item) => item.total || 'N/A' },
      };

      const pdfHead = checkedList.map(key => ({
        content: columnMap[key].label,
        styles: { halign: 'center', valign: 'middle' }
      }));

      const pdfRows = allData.map((item, idx) =>
        checkedList.map(key => columnMap[key].getValue(item, idx))
      );

      pdf.autoTable({
        startY: margin.top,
        theme: 'grid',
        margin: margin,
        rowPageBreak: 'auto',
        pageBreak: 'auto',
        showHead: 'everyPage',
        head: [pdfHead],
        body: pdfRows,
        styles: {
          font: 'times',
          halign: 'center',
          valign: 'middle',
          fontSize: 10,
          cellPadding: 3.5,
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          textColor: [0, 0, 0],
        },
        headStyles: {
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          fillColor: false,
        },
        bodyStyles: {
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        alternateRowStyles: { fillColor: false },
        didDrawPage: (data) => {
          const currentPage = pdf.internal.getCurrentPageInfo().pageNumber;
          const currentDateTime = dayjs().format('DD/MM/YYYY hh:mm:ss A');
          const footerY = pdf.internal.pageSize.height - footerHeight / 2;

          pdf.setFillColor(255, 255, 255);
          pdf.rect(
            margin.left,
            footerY - 15,
            pageWidth - margin.left - margin.right,
            footerHeight,
            'F'
          );
          pdf.setFontSize(10);
          pdf.text(currentDateTime, margin.left, footerY);
          pdf.text(`Page ${currentPage}`, pageWidth - margin.right - 70, footerY);

          if (currentPage === 1) {
            pdf.addImage(logo, 'PNG', pageWidth - 120, 10, 90, 25);
          }
        },
      });

      pdf.autoPrint();
      const pdfBlob = pdf.output('blob');
      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.right = '0px';
      iframe.style.bottom = '0px';
      iframe.style.width = '1px';
      iframe.style.height = '1px';
      iframe.style.border = 'none';
      iframe.src = URL.createObjectURL(pdfBlob);
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      };

    } catch (error) {
      console.error('Print error:', error);
      message.error('Failed to generate print.');
    } finally {
      setLoading(false);
    }
  };


  const columns = [
    {
      title: 'Sr No.',
      dataIndex: 'sr_no',
      key: 'sr_no',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: text => {
        const date = new Date(text);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      title: 'Shift A',
      dataIndex: 'shift_a',
      key: 'shift_a',
    },
    {
      title: 'Shift B',
      dataIndex: 'shift_b',
      key: 'shift_b',
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
    },
  ];

  const [checkedList, setCheckedList] = useState([
    'sr_no',
    'date',
    'shift_a',
    'shift_b',
    'total',
  ]);

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };

  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="sr_no" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="date">Date</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="shift_a">Shift A</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="shift_b">Shift B</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="total">Total</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Packing Report</h2>
              <div className="bredcrumbwrp">
                <Link
                  className="back"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Packing Report' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <RangePicker
                value={dateRange}
                format="DD-MM-YYYY"
                onChange={handleDateRangeChange}
                style={{ width: '300px', marginRight: '10px' }}
                presets={{
                  Today: [dayjs(), dayjs()],
                  'This Week': [dayjs().startOf('week'), dayjs()],
                  'This Month': [dayjs().startOf('month'), dayjs()],
                  'Last Month': [
                    dayjs().subtract(1, 'month').startOf('month'),
                    dayjs().subtract(1, 'month').endOf('month'),
                  ],
                }}
              />
              <Space size="small">
                <Input
                  placeholder="Search"
                  className="searchbox"
                  prefix={<SearchOutlined />}
                  value={search}
                  style={{ width: 190 }}
                  onChange={handleSearch}
                />
                <Tooltip title="Filter">
                  <Button
                    type="primary"
                    disabled={!search && !orderBy}
                    className="iconlink"
                    onClick={resetFilter}
                  >
                    <FilterIcon />
                  </Button>
                </Tooltip>
                {currentUser.permissions.permissions.bundle_inward.includes(
                  'print_packing_report_copy',
                ) && (
                    <Tooltip title="Print">
                      <Button
                        type="primary"
                        className="iconlink"
                        onClick={handlePrintDownloadAll}
                      >
                        <PrintIcon />
                      </Button>
                    </Tooltip>
                  )}
                {currentUser.permissions.permissions.bundle_inward.includes(
                  'download_packing_report_excel_copy',
                ) && (
                    <Tooltip title="Export to Excel">
                      <CSVLink
                        data={csvData}
                        headers={csvHeaders}
                        filename={`packing_report_${dayjs().format('YYYY-MM-DD')}.csv`}
                        enclosingCharacter={'"'}
                        style={{ display: 'inline-block' }}
                      >
                        <Button type="primary" className="iconlink">
                          <FileExcelOutlined />
                        </Button>
                      </CSVLink>
                    </Tooltip>
                  )}
                <div className="gridiconswrap">
                  <Tooltip placement="topLeft" title="Column Filter Options">
                    <Dropdown
                      overlay={columnMenu}
                      trigger={['click']}
                      placement="bottomRight"
                      visible={dropdownVisible}
                      onVisibleChange={setDropdownVisible}
                    >
                      <Button
                        type="primary"
                        icon={<ColumnList />}
                        onClick={e => e.preventDefault()}
                      />
                    </Dropdown>
                  </Tooltip>
                </div>
              </Space>
            </Col>
          </Row>
        </div>
      </div>

      <Spin spinning={loading} >
        <div id="printable-table">
          <Table
            rowKey="key"
            columns={filteredColumns}
            dataSource={mappedData}
            pagination={false}
            onChange={handleTableChange}
          />
        </div>
      </Spin>
      <Table
        rowKey="key"
        columns={filteredColumns}
        dataSource={mappedData}
        pagination={{
          current: page,
          pageSize: pagesize,
          showTotal: total => `Total ${total} items`,
          onChange: handlePageChange,
        }}
        style={{ display: 'none' }}
        onChange={handleTableChange}
      />
    </div>
  );
}

export default PackingReportList;
